import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-68880916"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "btn-content flex-end"
};
const _hoisted_3 = {
  class: "btn-content"
};
const _hoisted_4 = {
  key: 0,
  class: "handle-content"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 0
};
import { message, Modal } from 'ant-design-vue';
import { awaitWrap, OK, reportEvent } from '@/common';
import WhiteAddModal from '@/views/payManage/whitelistManage/components/WhiteAddModal.vue';
import { batchDeleteWhiteList, deleteWhiteList, queryWhiteList } from '@/api/whitelist';
export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteTableBlock',
  setup(__props, {
    expose
  }) {
    const routeName = computed(() => useRoute().name);
    const columns = [{
      title: '产品名',
      dataIndex: 'appName',
      key: 'appName'
    }, {
      title: 'DBTID',
      dataIndex: 'dbtId',
      key: 'dbtId'
    }, {
      title: '主体/账号',
      dataIndex: 'accountName',
      key: 'accountName'
    }, {
      title: '支付渠道',
      dataIndex: 'payChnl',
      key: 'payChnl'
    }, {
      title: '设备ID',
      dataIndex: 'deviceIds',
      key: 'deviceIds'
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      width: 200,
      align: 'right'
    }];
    const tableLoading = ref(false);
    const visible = ref(false);
    const dataSource = ref([]); // 表格数据
    const pageIndex = ref(1); // 当前页
    const pageSize = ref(20); // 每页条数
    const pageTotal = ref(0); // 总条数
    const searchObj = ref({}); // 搜索条件
    const tableRef = ref(); // 表格ref
    const edItem = ref({}); // 编辑项
    const selectedRowKeys = ref([]); // 选中的行
    const getData = async () => {
      const startTime = new Date().getTime();
      let params = {
        pageNum: pageIndex.value,
        pageSize: pageSize.value
      };
      Object.keys(searchObj.value).forEach(item => {
        if (searchObj.value[item] || searchObj.value[item] === 0) {
          params = {
            ...params,
            [item]: searchObj.value[item]
          };
        }
      });
      dataSource.value = [];
      tableLoading.value = true;
      const [err, data] = await awaitWrap(queryWhiteList(params));
      if (data && data.code === OK) {
        const res = (data === null || data === void 0 ? void 0 : data.data) || {
          list: [],
          total: 0
        };
        pageTotal.value = res === null || res === void 0 ? void 0 : res.total;
        dataSource.value = res.list;
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '验单白名单',
            app_name: '',
            return_duration: new Date().getTime() - startTime,
            query_status: 'succeed'
          }
        });
      }
      if (err) {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '验单白名单',
            app_name: '',
            return_duration: new Date().getTime() - startTime,
            query_status: 'failed'
          }
        });
      }
      tableLoading.value = false;
    }; // 获取表格数据
    const searchData = async obj => {
      pageIndex.value = 1;
      searchObj.value = obj;
      await getData();
    }; // 搜索
    const changePage = async (page, pageS) => {
      pageIndex.value = page;
      pageSize.value = pageS;
      await getData();
    }; // 分页
    const addProduct = () => {
      visible.value = true;
    }; // 新增产品
    const editItem = item => {
      var _item$deviceIds;
      edItem.value = {
        ...item,
        deviceIds: (_item$deviceIds = item.deviceIds) === null || _item$deviceIds === void 0 ? void 0 : _item$deviceIds.join(';')
      };
      visible.value = true;
    }; // 编辑
    const deleteItem = item => {
      Modal.confirm({
        title: '提示',
        content: '确认将该产品移除验单白名单？',
        centered: true,
        async onOk() {
          const [err, data] = await awaitWrap(deleteWhiteList({
            id: item.id
          }));
          if (data && data.code === OK) {
            message.success('删除成功');
            await getData();
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '验单白名单',
                element_name: '删除'
              }
            });
          }
          if (err) {}
        }
      });
    }; // 删除
    const clearEditItem = () => {
      edItem.value = {};
    }; // 清空编辑项
    const batchDelete = () => {
      if (selectedRowKeys.value.length === 0) return message.warning('请选择要删除的产品');
      Modal.confirm({
        title: '提示',
        content: '确认将选中的产品移除验单白名单？',
        centered: true,
        async onOk() {
          const ids = selectedRowKeys.value;
          const [err, data] = await awaitWrap(batchDeleteWhiteList({
            ids
          }));
          if (data && data.code === OK) {
            message.success('删除成功');
            await getData();
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '验单白名单',
                element_name: '批量删除'
              }
            });
          }
          if (err) {}
        }
      });
    };
    const onSelectChange = keys => {
      selectedRowKeys.value = keys;
    }; // 选中行
    expose({
      searchData
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        onClick: addProduct,
        class: "add-btn"
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "add",
          class: "add-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 新增白名单 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: _unref(routeName),
        btnType: 'add'
      }]]), _withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        danger: "",
        onClick: batchDelete,
        class: "add-btn"
      }, {
        default: _withCtx(() => [_createTextVNode(" 批量删除 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: _unref(routeName),
        btnType: 'del'
      }]])])]), _createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef,
        loading: tableLoading.value,
        "row-selection": {
          selectedRowKeys: selectedRowKeys.value,
          onChange: onSelectChange
        }
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [record['filterType'] !== 'payChnl' ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          type: "link",
          onClick: $event => editItem(record)
        }, {
          default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
          _: 2
        }, 1032, ["onClick"])), [[_directive_permission, {
          permissionValue: _unref(routeName),
          btnType: 'update'
        }]]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_a_button, {
          type: "link",
          onClick: $event => deleteItem(record)
        }, {
          default: _withCtx(() => [_createTextVNode(" 删除 ")]),
          _: 2
        }, 1032, ["onClick"])), [[_directive_permission, {
          permissionValue: _unref(routeName),
          btnType: 'del'
        }]])])) : _createCommentVNode("", true), column.dataIndex === 'deviceIds' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [record.filterType === 'payChnl' ? (_openBlock(), _createElementBlock("div", _hoisted_6, "全部")) : (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 1
        }, {
          title: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record[column.dataIndex], i => {
            return _openBlock(), _createElementBlock("div", {
              class: "elli-multiple-2",
              key: i
            }, _toDisplayString(i), 1);
          }), 128))]),
          default: _withCtx(() => {
            var _record$column$dataIn;
            return [_createElementVNode("span", null, _toDisplayString((_record$column$dataIn = record[column.dataIndex]) === null || _record$column$dataIn === void 0 ? void 0 : _record$column$dataIn[0]), 1)];
          }),
          _: 2
        }, 1024))])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data-source", "loading", "row-selection"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"]), _createVNode(WhiteAddModal, {
        "modal-visible": visible.value,
        "onUpdate:modal-visible": _cache[2] || (_cache[2] = $event => visible.value = $event),
        onRefresh: getData,
        "edit-item": edItem.value,
        onClearEditItem: clearEditItem
      }, null, 8, ["modal-visible", "edit-item"])]);
    };
  }
});